// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__zgRQx","top":"styles_top__3wg7y"};